import aiInventory from './aiInventory'
import aiInventoryPurposes from './aiInventoryPurposes'
import aiInventoryRiskOptions from './aiInventoryRiskOptions'
import aiInventoryTools from './aiInventoryTools'
import auth from './auth'
import company from './company'
import daiOptOut from './daiOptOut'
import departments from './departments'
import privacyByDesign from './privacyByDesign'
import profile from './profile'
import regulationVersions from './regulationVersions'

export default {
  aiInventory,
  aiInventoryPurposes,
  aiInventoryRiskOptions,
  aiInventoryTools,
  auth,
  company,
  daiOptOut,
  departments,
  privacyByDesign,
  profile,
  regulationVersions,
}
